import script from "./SliderInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./SliderInput.vue?vue&type=script&setup=true&lang=ts"

import "./SliderInput.vue?vue&type=style&index=0&id=8403f59a&scoped=true&lang=css"

import exportComponent from "/Users/jgividen/Local Sites/aph-font-testing/app/public/wp-content/plugins/aph-font-app/assets/js/component-lib/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8403f59a"]])

export default __exports__